import React from 'react';
import ATable from '../../organisms/ATable';

interface SoftwarePortfolioModalContentProps {
    data: any;
    type: 'frameworks' | 'dependencies' | 'ignored_dirs';
}

const SoftwarePortfolioModalContent: React.FC<SoftwarePortfolioModalContentProps> = ({ data, type }) => {
    if (!data || (Array.isArray(data) && data.length === 0) || (typeof data === 'object' && Object.keys(data).length === 0)) {
        return <p className="text-gray-500 p-4">Nenhum item encontrado.</p>;
    }

    switch (type) {
        case 'frameworks':
            return (
                <ATable headers={[
                    { id: 'name', title: 'Framework', canSort: false },
                    { id: 'version', title: 'Versão', canSort: false }
                ]} autoResize={false}>
                    {Object.entries(
                        (data && typeof data === 'object' && !Array.isArray(data) ? data : {})
                    ).map(([name, version], index) => (
                        <tr key={name} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                            <td className="px-2 py-1 border-b">{name}</td>
                            <td className="px-2 py-1 border-b">{String(version)}</td>
                        </tr>
                    ))}
                </ATable>
            );
        case 'dependencies':
            return (
                <ATable headers={[
                    { id: 'name', title: 'Dependência', canSort: false },
                    { id: 'version', title: 'Versão', canSort: false }
                ]} autoResize={false}>
                    {(data as any[]).map((dep, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                            <td className="px-2 py-1 border-b">{dep.name}</td>
                            <td className="px-2 py-1 border-b">{dep.version}</td>
                        </tr>
                    ))}
                </ATable>
            );
        case 'ignored_dirs':
            return (
                <ATable headers={[
                    { id: 'name', title: 'Diretório Ignorado', canSort: false }
                ]} autoResize={false}>
                    {(data as string[]).map((dir, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                            <td className="px-2 py-1 border-b">{dir}</td>
                        </tr>
                    ))}
                </ATable>
            );
        default:
            return null;
    }
};

export default SoftwarePortfolioModalContent;
